import React from "react";

export type MrclInputTextProps = {
  label: string;
  hideLabel?: boolean;
  helperText?: string;
  icon?: string;
} & React.InputHTMLAttributes<HTMLElement>;

const MrclInputText = ({ onChange, className, hideLabel, helperText, ...rest }: MrclInputTextProps) => (
  // Marcel's input dispatches a native `input` event rather than React's synthetic
  // `change`, so both handlers are wired to the same callback for React controlled-input parity.
  <mrcl-input-text
    onChange={onChange}
    onInput={onChange}
    class={className}
    hide-label={hideLabel || undefined}
    helper-text={helperText}
    {...rest}
  />
);

export default MrclInputText;
